export default __webpack_public_path__ + "static/media/cescon.98d4b195.png";